import { render, staticRenderFns } from "./DresdenLevel.vue?vue&type=template&id=937cd71e&scoped=true&"
import script from "./DresdenLevel.vue?vue&type=script&lang=js&"
export * from "./DresdenLevel.vue?vue&type=script&lang=js&"
import style0 from "./DresdenLevel.vue?vue&type=style&index=0&id=937cd71e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937cd71e",
  null
  
)

export default component.exports